import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=c268b7f8&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/newsList.scss?vue&type=style&index=0&id=c268b7f8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c268b7f8",
  null
  
)

export default component.exports